/**
 * @fileoverview
 * Loading Service - Manages global loading state
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private activeRequests = 0;
  private loadingSignal = signal<boolean>(false);

  // Public readonly signal
  readonly loading = this.loadingSignal.asReadonly();

  /**
   * Show loading indicator
   */
  show(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.loadingSignal.set(true);
    }
  }

  /**
   * Hide loading indicator
   */
  hide(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0) {
      this.loadingSignal.set(false);
    }
  }

  /**
   * Reset loading state (force hide)
   */
  reset(): void {
    this.activeRequests = 0;
    this.loadingSignal.set(false);
  }
}

